import * as React from "react";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import {
    Policy,
    Renewal,
    PREMIUM_TYPE_MONTHLY,
    ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    PaymentsResponse,
    InstalmentsInfo,
    resourcesHelper,
    INTERACTION_PROCESS_MTA
} from "@falcon/services";
import {formatDateDMY, getAmountToDisplay} from "../../CommonFunctions";
import {Link} from "react-router-dom";

interface IProps {
    currentPolicy: Policy;
    renewalProposal: Renewal;
    payment?: PaymentsResponse;
    instalmentsInfo?: InstalmentsInfo;
    turnOnNextYearRenewal: () => void;
}

interface IState {
    isOpen: boolean;
    monthlyPayments: boolean;
}

export class AnnualHomeManualRenewalModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: true,
            monthlyPayments: this.props.renewalProposal.factors.premiumType === PREMIUM_TYPE_MONTHLY
        };

        this.close = this.close.bind(this);
    }

    public render(): React.ReactNode {
        const closeBtn: React.ReactNode = <button className="btn-close" onClick={this.close}/>
        const policyHolder: any = this.props.currentPolicy.policyHolder;
        const renewalProposal: Renewal = this.props.renewalProposal;
        const renewalStartDate: string | null = formatDateDMY(renewalProposal.headerInfo.startDate);
        const currentPolicyInteraction: any = this.props.currentPolicy.interaction;
        const inGracePeriod: boolean = this.props.currentPolicy.annualPolicyInfo != null ? this.props.currentPolicy.annualPolicyInfo.inGracePeriod : false;
        const policyEndDate: string | null = formatDateDMY(currentPolicyInteraction.headerInfo.endDate);



        const annualRenewalPrice: number = renewalProposal.factors.annualPremium;
        const monthlyRenewalPayment: number = renewalProposal.paymentDetails.instalmentPlan.monthlyPayment;
        const monthlyRenewalTotalAmount: number = renewalProposal.paymentDetails.instalmentPlan.totalAmount;

        const annualLastYearPrice: number = currentPolicyInteraction.factors.annualPremium;
        const monthlyLastYearPayment: number = currentPolicyInteraction.paymentDetails.instalmentPlan.monthlyPayment;
        const monthlyLastYearTotalAmount: number = currentPolicyInteraction.paymentDetails.instalmentPlan.totalAmount;

        const totalAmountFromExistingPayments: number = this.getTotalAmountFromExistingPayments();
        const monthlyTotalLastYearPriceAfterMTA: string = totalAmountFromExistingPayments.toFixed(2);
        const monthlyLastYearPriceAfterMTA: string = (totalAmountFromExistingPayments / 12).toFixed(2)

        const monthlyLastYearPrice: any = this.props.currentPolicy.interaction.process === INTERACTION_PROCESS_MTA ? monthlyLastYearPriceAfterMTA : monthlyLastYearPayment;
        const monthlyTotalLastYearPrice: any = this.props.currentPolicy.interaction.process === INTERACTION_PROCESS_MTA ? monthlyTotalLastYearPriceAfterMTA : monthlyLastYearTotalAmount;

        return (
            <Modal className="renewal-modal" isOpen={this.state.isOpen}>
                <ModalHeader close={closeBtn}/>
                <ModalBody>
                    <div className="header">
                        <span>Hi {policyHolder.firstName},</span>
                    </div>
                    {!inGracePeriod && this.stillActivePolicyWording(policyHolder, renewalStartDate)}
                    {inGracePeriod && this.inGracePeriodWording(policyHolder, policyEndDate)}
                    <div className="container">
                        <div className="left">
                            <div className="font-weight-bold">Renewal price</div>
                            {this.state.monthlyPayments &&
                                <div>You will pay {getAmountToDisplay(monthlyRenewalPayment)} / month</div>}
                        </div>
                        <div
                            className="right font-weight-bold">{this.state.monthlyPayments ? getAmountToDisplay(monthlyRenewalTotalAmount) : getAmountToDisplay(annualRenewalPrice)}</div>
                    </div>
                    <div className="container">
                        <div className="left">
                            <div className="font-weight-bold">Last year`s price</div>
                            {this.state.monthlyPayments &&
                                <div>You paid {getAmountToDisplay(monthlyLastYearPrice)} / month</div>}
                        </div>
                        <div
                            className="right font-weight-bold">{this.state.monthlyPayments ? getAmountToDisplay(monthlyTotalLastYearPrice) : getAmountToDisplay(annualLastYearPrice)}*
                        </div>
                    </div>
                    <div className="twentyFontSize mt-3">
                        <div>* Including any changes made</div>
                        <div>All figures include Insurance Premium Tax.</div>
                    </div>
                    <div className="twentyFourFontSize font-weight-bold mt-3">Please take a minute to have a good read
                        of your&nbsp;
                        <Link className="color-cyan-blue"
                              to={`/dashboard/annualHomeDocuments/${this.props.currentPolicy.policyNumber}`}>
                            <span className="hyperlink">renewal documents</span>
                        </Link>, just to make sure all your
                        details are correct.
                    </div>
                </ModalBody>
                <div className="shadow mt-3">
                    <ModalFooter>
                        <button type="button" className="btn btn-back btn-modal mr-3" onClick={this.close}>Not just yet
                        </button>
                        {inGracePeriod &&
                            <Link
                                className="btn btn-primary btn-modal"
                                to={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.props.renewalProposal._id}>Renew your policy now
                            </Link>
                        }
                        {!inGracePeriod &&
                            <button type="button" className="btn btn-primary btn-modal" onClick={this.setRenewal}>Renew your
                            policy
                            now
                        </button>
                        }
                    </ModalFooter>
                </div>
            </Modal>
        )
    }


    private stillActivePolicyWording(policyholder: any, renewalStartDate: string | null): React.ReactNode {
        return (
            <div>your current <span className="font-weight-bold">home cover for {policyholder.address.addressLine1},… {policyholder.address.postalCode} is due for renewal</span> on {renewalStartDate}.
            </div>
        )
    }

    private inGracePeriodWording(policyholder: any, policyEndDate: string | null): React.ReactNode {
        return (
            <div>You are no longer covered. Your <span className="font-weight-bold">{resourcesHelper.PRODUCT} Home Insurance policy
                for {policyholder.address.addressLine1},… {policyholder.address.postalCode} ended on {policyEndDate}.</span>
                <p className="pb-20">
                    <span className="font-weight-bold">It’s not too late to renew now</span>
                </p>
            </div>
        )
    }

    private getTotalAmountFromExistingPayments(): number {
        if (this.props.payment && this.props.instalmentsInfo) {
            let totalPayment = 0;
            this.props.payment?.paymentDetailsList.forEach(pd => totalPayment += pd.amount)
            if (this.props.instalmentsInfo?.payOffAmountWithRemainingInterest) {
                totalPayment = totalPayment + this.props.instalmentsInfo.payOffAmountWithRemainingInterest;
            }
            return totalPayment;
        }
        else {
            return 0;
        }
    }

    private close(): void {
        window.sessionStorage.setItem("manualRenewalPopUpIsShown", "true")
        this.setState((prevState: Readonly<IState>) =>
            ({isOpen: !prevState.isOpen})
        )
    }

    private setRenewal = (): void => {
        this.close()
        this.props.turnOnNextYearRenewal();
    }
}
